import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  cleanJsonString(jsonString: string): string {
    const toReplace = new RegExp('`', 'g');
    var cleanedJsonString = jsonString
      .split(';')[0]
      .replace(toReplace, '')
      .trim();
    cleanedJsonString = cleanedJsonString.replace(/,\s*([}\]])/g, '$1');
    return this.stripJSON(cleanedJsonString);
  }

  stripJSON(jsonString: string): string {
    const startIndex = jsonString.indexOf('{');
    const endIndex = jsonString.lastIndexOf('}');

    if (startIndex === -1 || endIndex === -1) {
      console.error('Invalid JSON string - returning empty string');
      return '';
    }

    return jsonString.substring(startIndex, endIndex + 1);
  }
}
